import { Routes } from '@angular/router';
import { AdministrationComponent } from './administration.component';
import { ReferencesResolver } from './resolvers/references.resolver';
import { ORGANISMES_ROUTE_DATA, ORGANISMES_ROUTES } from './pages/organismes/organismes.routes';
import { UTILISATEURS_ROUTE_DATA, UTILISATEURS_ROUTES } from './pages/utilisateurs/utilisateurs.routes';
import { JURES_ROUTE_DATA, JURES_ROUTES } from './pages/jures/jures.routes';
import { DROITS_ROUTES } from './pages/droits/droits.routes';
import { PROFILS_ROUTES } from './pages/profils/profils.routes';
import { ENTREPRISES_ROUTE_DATA, ENTREPRISES_ROUTES } from './pages/entreprises/entreprises.routes';
import { CONTACTS_ROUTE_DATA, CONTACTS_ROUTES } from './pages/contacts/contacts.routes';
import { INTERACTIONS_ROUTE_DATA, INTERACTIONS_ROUTES } from './pages/interactions/interactions.routes';
import { CAMPAGNES_ROUTES } from './pages/campagnes/campagnes.routes';
import { VALEURS_PARAM_ROUTE_DATA, VALEURS_PARAM_ROUTES } from './pages/valeurs-parametrables/valeurs-parametrables.routes';
import { EDITION_ROUTES } from '../edition/edition.routes';
import { EMAILS_ADMIN_ROUTES, EMAILS_ROUTE_ADMIN_DATA, EMAILS_ROUTE_DATA, EMAILS_ROUTES } from './pages/emails/emails.routes';

export const ADMINISTRATION_ROUTE_DATA = {
    role: 'ADMIN || (ORGANISME && (INTERVENANT_ORGANISME_LISTE_LECTURE || INTERVENANT_UTILISATEUR_LECTURE))',
    menu: {
        icon: 'cog',
        libelle: 'menu.administration'
    }
};

export const ADMINISTRATION_ROUTES: Routes = [
    { path: '', redirectTo: 'params', pathMatch: 'full' },
    {
        path: '',
            component: AdministrationComponent,
            data: ADMINISTRATION_ROUTE_DATA,
            resolve: {
                references: ReferencesResolver
        },
        children: [
            { path: '', redirectTo: 'organismes', pathMatch: 'full' },
            { path: 'organismes', data: ORGANISMES_ROUTE_DATA, children: ORGANISMES_ROUTES },
            { path: 'jures', data: JURES_ROUTE_DATA, children: JURES_ROUTES },
            { path: 'template', children: EDITION_ROUTES },
            { path: 'droits', children: DROITS_ROUTES },
            { path: 'profils', children: PROFILS_ROUTES },
            { path: 'utilisateurs', data: UTILISATEURS_ROUTE_DATA, children: UTILISATEURS_ROUTES },
            { path: 'entreprises', data: ENTREPRISES_ROUTE_DATA, children: ENTREPRISES_ROUTES },
            { path: 'contacts', data: CONTACTS_ROUTE_DATA, children: CONTACTS_ROUTES },
            { path: 'interactions', data: INTERACTIONS_ROUTE_DATA, children: INTERACTIONS_ROUTES },
            { path: 'campagnes', children: CAMPAGNES_ROUTES },
            { path: 'listes', data: VALEURS_PARAM_ROUTE_DATA, children: VALEURS_PARAM_ROUTES },
            { path: 'mails', data: EMAILS_ROUTE_DATA, children: EMAILS_ROUTES },
            { path: 'param_mails', data: EMAILS_ROUTE_ADMIN_DATA, children: EMAILS_ADMIN_ROUTES }
        ]
    }
];
